<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-truck"></i></span>{{ 'LeaveWarehouse.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <div class="flex justify-content-end">
          <laas-search-form-parameter-group [formName]="preferenceKey" [parameters]="searchParams"
          (parameterGroupChange)="parameterGroupChange($event)" (unBookmarked)="unBookmarked($event)">
        </laas-search-form-parameter-group>
        </div>
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'LeaveWarehouse.Form.LeaveWarehouseKey' | translate }}</label>
              <p-chips formControlName="leaveWarehouseKeyList" [(ngModel)]="searchParams.leaveWarehouseKeyList" separator=","></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'LeaveWarehouse.Form.CarTrip' | translate }}</label>
              <p-chips formControlName="carTripList" [(ngModel)]="searchParams.carTripList" separator=","></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'LeaveWarehouse.Form.Status' | translate }}</label>
              <p-dropdown [options]="statusOptions" [(ngModel)]="searchParams.status" [showClear]="true"
                formControlName="status" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'BookingSearch.Form.Forwarder' | translate }}</label>
              <div class="item">
                  <p-multiSelect [options]="bookingForwarderList"  [(ngModel)]="searchParams.bookingForwarderList"
                  formControlName="bookingForwarderList"  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  optionLabel="optionDesc" optionValue="optionCode" [filter]="true" filterBy="optionDesc">
                </p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="mb-1">{{ 'LeaveWarehouse.Form.LicensePlate' | translate }}</div>
              <p-chips formControlName="licensePlateList" [(ngModel)]="searchParams.licensePlateList" separator=","></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="mb-1">{{ 'LeaveWarehouse.DetailForm.DoNo' | translate }}</div>
              <p-chips formControlName="doNoList" [(ngModel)]="searchParams.doNoList" separator=","></p-chips>
            </div>

            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                #signatureDt
                [title]="'LeaveWarehouse.Form.SignatureDt'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event,'SignatureDt')">
              </laas-calendar>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchBtnClick($event)"></button>
              <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-2"
                (click)="resetBtnClick($event)"></button>
            </div>
          </div>

        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <p-table #leaveWarehouseTable laasDataTableSetting selectionMode="single" [tableKey]="preferenceKey" [defaultColumns]="columns" [value]="leaveWarehouseRows"
        [loading]="isLoading" [lazy]="true" [rows]="pageInfo.pageSize" [totalRecords]="pageInfo.totalRecords"
        (setPageSize)="setPageSize($event)" (onSort)="tableSort($event)" (onPage)="tablePageChange($event)" class="datatable" >


        <ng-template pTemplate="caption">
          <div class="flex align-items-center">
            <laas-table-column-toggle
              [optionsColumn]="columns"
              [dataTable]="leaveWarehouseTable">
            </laas-table-column-toggle>
            <p-menubar [model]="mainItemMenus" styleClass="ml-2"></p-menubar>
        </div>
        </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" *ngFor="let col of columns" pResizableColumn pReorderableColumn [attr.field]="col.field">
              {{ col.header | translate }}
              <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns" (click)="searchDetailClick($event, rowData)">
              <div [ngSwitch]="col.field">
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith:'-'}}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'status'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:statusOptions | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'createDt'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'updateDt'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'signatureDt'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </div>
                </ng-container>

                <ng-template #displayEmpty>
                  -
                </ng-template>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length + 1">
              {{ 'Common.Table.NoData' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="mt-2">
      <p-table #leaveWarehouseDetailTable laasDataTableSetting selectionMode="single" [tableKey]="detailPreferenceKey" [defaultColumns]="detailColumns" [value]="leaveWarehouseDetailRows"
        [loading]="isLoading" [lazy]="true" [rows]="detailPageInfo.pageSize" [totalRecords]="detailPageInfo.totalRecords"
        (onSort)="detailTableSort($event)" (onPage)="detailTablePageChange($event)" class="datatable" >
        <ng-template pTemplate="caption">
          <laas-table-column-toggle
            [optionsColumn]="detailColumns"
            [dataTable]="leaveWarehouseDetailTable">
          </laas-table-column-toggle>
        </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" *ngFor="let col of columns" pResizableColumn pReorderableColumn [attr.field]="col.field">
              {{ col.header | translate }}
              <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns">
              <div [ngSwitch]="col.field">
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-template #displayEmpty>
                  -
                </ng-template>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length + 1">
              {{ 'Common.Table.NoData' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="mt-2 text-center">
    </div>
  </p-card>

</div>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
